module.exports = __webpack_public_path__ + "img/9_001.fa7bb10d.webp";